export default __webpack_public_path__ + "static/media/svetlana_avatar.88e99bbb.jpg";